import {fetch} from '../utils/fetch';
import {casaApiUrl} from 'configs/casa-api';

import queryString from 'query-string';


function getCrossSellOpportunities(fetchCount, businessName, filters = {}) {
  let query = queryString.stringify({
    numberOfEntries: fetchCount || 5,
    business: businessName || '',
    comparisonField: _.isEmpty(filters) ? '' : _.get(filters.toJSON(), 'selectedCrossSellHierarchy', ''),
    productField: _.isEmpty(filters) ? '' : _.get(filters.toJSON(), 'selectedCrossSellHierarchy', ''),
    productMin: _.isEmpty(filters) ? '' : _.get(filters.toJSON(), 'crossSellProductMin', ''),
    productMax: _.isEmpty(filters) ? '' : _.get(filters.toJSON(), 'crossSellProductMax', ''),
    productsPerPageCount: _.isEmpty(filters) ? '' : _.get(filters.toJSON(), 'productsPerPageCount', ''),
    currentPageNumber: _.isEmpty(filters) ? '' : _.get(filters.toJSON(), 'crossSellPageNumber', '')
  }, {arrayFormat: 'bracket'});
  return fetch(`${casaApiUrl}/users/recommendations/cross-sell?${query}`, {
    credentials: 'include'
  })
    .then(r => r.json());
}

export default {
  getCrossSellOpportunities
}



// WEBPACK FOOTER //
// ./src/services/opportunities-service.js